import { keyframes } from 'styled-components/macro';

export const closeKeyframes = keyframes`
  from {
    opacity: 1;
    max-height: 200px;
  }
  to {
    opacity: 0;
    margin-block: 0;
    padding-block: 0;
    max-height: 0;
  }
`;

export const marqueeKeyframes = keyframes`
  from { transform: translateX(0); }
  to { transform: translateX(-50%); }
`;
